import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false,
})
export class UnauthorizedComponent {
  constructor(public router: Router) {}
  GoHome(): void {
    this.router.navigate(['/']);
  }
}
